module.exports = __webpack_public_path__ + "static/media/califormia_chese_forel.520e6958.webp";